<app-secondary-button (click)="luoTaikalinkki()" actionId="Luo kirjanpidon ulkopuoliset kulut taikalinkki"> Luo taikalinkki </app-secondary-button>

<form novalidate>
  <div style="margin-top: 50px">
    <div class="apk-form-upd">Lomake päivitetty: {{ lomakePaivitetty() }} {{ lomakkeenPaivittaja ? '(' + lomakkeenPaivittaja + ')' : '' }}</div>

    <div style="margin-top: 30px">
      <mat-checkbox [formField]="lomake.eiIlmoitettavaa"> </mat-checkbox>
      <span class="apk-checkbox-label">{{ 'ulkopuoliset-kulut.ei-ilmoitettavaa' | translate | async }}</span>
    </div>

    @if (commonError()) {
      <div class="red-text common-error" style="text-align: center">{{ commonError() }}</div>
    }

    @if (onIlmoitettavaa()) {
      <div class="apk-form-title">
        {{ 'ulkopuoliset-kulut.ajoneuvon-kaytto' | translate | async }}
      </div>
      <div>
        @for (rivi of lomake.ajoneuvot; track rivi; let i = $index) {
          <div class="ajnv-rivi">
            <mat-form-field class="ajnv-col">
              <mat-label>{{ 'ulkopuoliset-kulut.rekisteritunnus' | translate | async }}</mat-label>
              <input type="text" [formField]="rivi.rekisteritunnus" autocomplete="nothing" matInput data-lpignore="true" />
              <mat-error>
                @if (rivi.rekisteritunnus(); as n) {
                  @if (n.touched()) {
                    @if (onkoVirhe(rivi.rekisteritunnus, 'required')) {
                      {{ 'ulkopuoliset-kulut.field-error' | translate | async }}
                    }
                  }
                }
              </mat-error>
            </mat-form-field>
            <mat-form-field class="ajnv-col">
              <mat-label>{{ 'ulkopuoliset-kulut.ajoneuvotyyppi' | translate | async }}</mat-label>
              <mat-select [formField]="rivi.tyyppi">
                <mat-option value="henkilo">{{ 'ulkopuoliset-kulut.henkiloauto' | translate | async }}</mat-option>
                <mat-option value="paketti">{{ 'ulkopuoliset-kulut.pakettiauto' | translate | async }}</mat-option>
                <mat-option value="muu">{{ 'ulkopuoliset-kulut.muu-ajoneuvo' | translate | async }}</mat-option>
              </mat-select>
              <mat-error>
                @if (rivi.tyyppi(); as n) {
                  @if (n.touched()) {
                    @if (onkoVirhe(rivi.tyyppi, 'required')) {
                      {{ 'ulkopuoliset-kulut.field-error' | translate | async }}
                    }
                  }
                }
              </mat-error>
            </mat-form-field>
            <mat-form-field class="ajnv-col">
              <mat-label>{{ 'ulkopuoliset-kulut.ajettu-yhteensa' | translate | async }}</mat-label>
              <input decimalNumberField type="text" [formField]="rivi.kokonaisKmMaara" autocomplete="nothing" matInput data-lpignore="true" />
              <mat-error>
                @if (rivi.kokonaisKmMaara(); as n) {
                  @if (n.touched()) {
                    @if (onkoVirhe(rivi.kokonaisKmMaara, 'required')) {
                      {{ 'ulkopuoliset-kulut.field-error' | translate | async }}
                    }
                  }
                }
              </mat-error>
            </mat-form-field>
            <mat-form-field class="ajnv-col">
              <mat-label>{{ 'ulkopuoliset-kulut.ajettu-tyoajoa' | translate | async }}</mat-label>
              <input decimalNumberField type="text" [formField]="rivi.tyoAjoissaKm" autocomplete="nothing" matInput data-lpignore="true" />
              <mat-error>
                @if (rivi.tyoAjoissaKm(); as n) {
                  @if (n.touched()) {
                    @if (onkoVirhe(rivi.tyoAjoissaKm, 'required')) {
                      {{ 'ulkopuoliset-kulut.field-error' | translate | async }}
                    }
                    @if (!onkoVirhe(rivi.tyoAjoissaKm, 'required') && onkoVirhe(rivi.tyoAjoissaKm, 'toolarge')) {
                      {{ 'ulkopuoliset-kulut.auton-kaytto-tyoajoissa-too-large-error' | translate | async }}
                    }
                  }
                }
              </mat-error>
            </mat-form-field>
            <app-icon-button (click)="poistaAjoneuvo(i); $event.preventDefault()" actionId="Poista ajoneuvo (kirjanpidon ulkopuoliset kulut)" matIcon="delete"> </app-icon-button>
          </div>
        }
        <app-primary-button (click)="lisaaAjoneuvo(); $event.preventDefault()" actionId="Avattu muokkausnäkymä:  Lisää ajoneuvo rivi">
          <!-- {{'yleiset.jatka' | translate | async }} -->
          {{ 'ulkopuoliset-kulut.lisaa-ajoneuvo' | translate | async }}
        </app-primary-button>
      </div>
      <div [class.mat-form-field-invalid]="onkoVirhe(lomake.tiedotPerustuvat, 'required')" class="apk-radio-container indented-in-large-view">
        <div [class.dark-gray-text]="!lomake.ajoneuvot().value().length" class="apk-radio-label">
          {{ 'ulkopuoliset-kulut.auton-tiedot-perustuvat' | translate | async }}
          @if (lomake.ajoneuvot().value().length) {
            <span aria-hidden="true" class="mat-placeholder-required mat-form-field-required-marker"> *</span>
          }
        </div>
        <mat-radio-group [formField]="lomake.tiedotPerustuvat" style="display: flex; flex-direction: column">
          <mat-radio-button class="apk-radio-button" [class.field-error]="onkoVirhe(lomake.tiedotPerustuvat, 'required')" [value]="'ajopaivakirjaan'">{{ 'ulkopuoliset-kulut.ajopaivakirjaan' | translate | async }}</mat-radio-button>
          <mat-radio-button class="apk-radio-button" [class.field-error]="onkoVirhe(lomake.tiedotPerustuvat, 'required')" [value]="'muuhun selvitykseen'">{{ 'ulkopuoliset-kulut.muuhun-selvitykseen' | translate | async }}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="apk-form-title">
        {{ 'ulkopuoliset-kulut.kotimaan-tyomatkat' | translate | async }}
      </div>
      <mat-form-field class="tyomatkat-input">
        <mat-label>{{ 'ulkopuoliset-kulut.kokopaivarahojen-lukumaara' | translate | async }}</mat-label>
        <input decimalNumberField matInput [formField]="lomake.yli10hKotimaanMatkojenLukumaara" class="alignLeft" [numberOfDecimals]="0" />
        <mat-hint style="font-weight: bold">{{ 'ulkopuoliset-kulut.yli-10h-lukumaara' | translate | async }}</mat-hint>
      </mat-form-field>
      <mat-form-field class="tyomatkat-input">
        <mat-label>{{ 'ulkopuoliset-kulut.osapaivarahojen-lukumaara' | translate | async }}</mat-label>
        <input decimalNumberField matInput [formField]="lomake.yli6hKotimaanMatkojenLukumaara" class="alignLeft" [numberOfDecimals]="0" />
        <mat-hint style="font-weight: bold">{{ 'ulkopuoliset-kulut.yli-6h-lukumaara' | translate | async }}</mat-hint>
      </mat-form-field>
      <div class="apk-form-title">
        {{ 'ulkopuoliset-kulut.ulkomaan-tyomatkat' | translate | async }}
      </div>
      <mat-form-field class="tyomatkat-input">
        <mat-label>{{ 'ulkopuoliset-kulut.ulkomaan-lukumaara' | translate | async }}</mat-label>
        <input decimalNumberField matInput [formField]="lomake.ulkomaanMatkapaivienLukumaara" class="alignLeft" [numberOfDecimals]="1" />
      </mat-form-field>
      <mat-form-field class="tyomatkat-input">
        <mat-label>{{ 'ulkopuoliset-kulut.ulkomaan-paivarahojen-yhteismaara' | translate | async }}</mat-label>
        <input decimalNumberField matInput [formField]="lomake.ulkomaanPaivarahojenYhteismaara" class="alignLeft" />
        <mat-hint style="font-weight: bold">{{ 'ulkopuoliset-kulut.laske-ulkomaan-paivarahojen' | translate | async }}</mat-hint>
      </mat-form-field>
      <div class="apk-form-title">
        {{ 'ulkopuoliset-kulut.tyohuonevahennys' | translate | async }}
      </div>
      <mat-radio-group [formField]="lomake.kotiYrityksenTyotilana" style="display: flex; flex-direction: column">
        <mat-radio-button [value]="'ei-vahennysta'">
          <div class="apk-radio-option">{{ 'ulkopuoliset-kulut.ei-tyohuonevahennysta' | translate | async }}</div>
        </mat-radio-button>
        <mat-radio-button [value]="'paasaantoinen'">
          <div class="apk-radio-option">{{ 'ajopaivakirja.kotia-paasaantoisesti' | translate: { vahennys: paasaantoinenKotiVahennys } | async }}</div>
        </mat-radio-button>
        <mat-radio-button [value]="'osa-aikainen'">
          <div class="apk-radio-option">{{ 'ajopaivakirja.kotia-osa-aikaisesti' | translate: { vahennys: osaaikainenKotiVahennys } | async }}</div>
        </mat-radio-button>
        <mat-radio-button [value]="'satunnainen'">
          <div class="apk-radio-option">{{ 'ajopaivakirja.kotia-satunnaisesti' | translate: { vahennys: satunnainenKotiVahennys } | async }}</div>
        </mat-radio-button>
      </mat-radio-group>
    }
  </div>

  <div style="margin-top: 30px">
    <div>
      <app-primary-button (click)="tallenna()" actionId="Tallenna kirjanpidon ulkopuoliset kulut lomake" [actionContext]="$any(lomake().value())">Tallenna</app-primary-button>
    </div>
  </div>
</form>
